import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom'
import cover from '../../../../Assets/Images/noskhe-cover.jpg'
import PlayListSong from "./PlayListSong";
import MoreItem from "../MoreItem";

import 'swiper/css/scrollbar';


function PlayListContent(props) {
    const navigate = useNavigate();
    const [album, setAlbum] = useState({
        name: 'نسخه',
        /*artist: 'هیپاپولوژیست',*/
        artist: {name: 'هیپاپولوژیست', id: '5'},
        genre: 'رپ',
        dateAdd: '1402/03/01',
        songs: [
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
            {name: 'داستان', time: '3:25', id: 56},
        ]
    })

    return (
        <div className='flex flex-col'>
            <div className="text-2lg font-bolder">PLAYLIST</div>
            <div className="flex flex-row items-center mb-8">
                <img src={cover} alt='cover' className='w-[300px] rounded-xl ml-6'/>
                <div className="flex flex-col">
                    <div className='text-3xl font-bold mb-4'>{album.name}</div>
                    <div className='text-base text-gray-600 mb-2'
                         onClick={() => navigate('/artist/5')}>{album.artist.name}</div>
                    <div className='text-base text-gray-600 mb-2'>{album.genre}</div>
                    <div className='text-base text-gray-600 mb-2'>{album.dateAdd}</div>
                </div>
            </div>
            <div className="flex flex-col space-y-4">
                {
                    album.songs.map((song, index) =>
                        <>
                            <PlayListSong name={song.name} time={song.time} id={song.id}/>
                        </>
                    )
                }
            </div>
            <div className="flex flex-col mt-8 py-20">
                <div className="flex flex-row items-center text-main font-bold text-lg">
                    <span className='ml-2'>آثار بیشتر</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                         stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
                    </svg>
                </div>
                {/*<MoreItem/>
                <MoreItem/>
                <MoreItem/>
                <MoreItem/>
                <MoreItem/>
                <MoreItem/>*/}




            </div>
        </div>
    );
}

export default PlayListContent;